<template>
  <div
    v-if="res"
    id="page"
    :class="{
      remainPre: isRemain && buttonType === 'perpay',
      noremainPre: !isRemain && buttonType === 'perpay',
      remainFinal: isRemain && buttonType === 'final_payment',
      noremainFinal: !isRemain && buttonType === 'final_payment',
      guide: buttonType === 'guide',
    }"
  >
    <!-- 头图 -->
    <div v-if="headerRes" class="header-wrap">
      <Header :res="headerRes"></Header>
    </div>
    <!-- 课程介绍 -->
    <div v-if="contentRes" class="content-wrap">
      <Content :res="contentRes"></Content>
    </div>
    <!--  协议  -->
    <div
      v-if="isSwitch"
      class="agreement-btn"
      :class="{
        remainPreAgre: isRemain && buttonType === 'perpay',
        noremainPreAgre: !isRemain && buttonType === 'perpay',
        remainFinalAgre: isRemain && buttonType === 'final_payment',
        noremainFinalAgre: !isRemain && buttonType === 'final_payment',
      }"
    >
      <div v-if="isShowSelect && buttonType !== 'guide'" class="select-wrap">
        <img
          v-if="!isClicked"
          class="selected"
          src="../assets/right.svg"
          :style="`background-color:${selectColor}`"
          @click="agreeHandle(true)"
        />
        <img v-else class="unselect" src @click="agreeHandle(false)" />
      </div>
      <span class="option-text" :style="`color:${txtColor}`">{{
        agPrefix
      }}</span>
      <span
        class="option-agreement"
        :style="`color:${agreeColor}`"
        @click="showAgreement"
        >{{ agName }}</span
      >
      <span
        class="option-agreement policy"
        :style="`color:${agreeColor}`"
        @click="showPolicy"
        >《隐私政策》</span
      >
    </div>
    <!-- 底部按钮 -->
    <div v-if="bottomRes" class="bottom-wrap">
      <Bottom
        :res.sync="bottomRes"
        :topRes="topRes"
        :isClicked="isClicked"
        :sensor="sensorRes"
        @sendGetChargeStatusReq="sendGetChargeStatusReq"
      ></Bottom>
    </div>
    <!--  协议  -->
    <div v-if="isShowAgreement" class="agreement-wrap">
      <Agreement :res="agreementRes" @closeHandle="closeHandle"></Agreement>
    </div>
    <!-- 隐私 -->
    <div v-if="isShowPolicy" class="agreement-wrap">
      <Agreement :res="policyData" @closeHandle="closePolicy"></Agreement>
    </div>
  </div>
</template>

<script>
import Header from '@component/enrolment-comp/header.vue';
import Content from '@component/enrolment-comp/content.vue';
import Agreement from '@component/enrolment-comp/agreement.vue';
import Bottom from '../components/activity-bottom.vue';
import { getCookie, setCookie, getQueryFromSearch } from '@/lib/util.ts';
import { CHARGE_ID, TIME_RECORD_BEGIN, COUNT_DOWN, EXPIRES } from '../types';
import trackerLoaded, { patchTracker } from '@lib/tracker';

const INTERVAL = 300;

export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Header,
    // eslint-disable-next-line vue/no-reserved-component-names
    Content,
    Agreement,
    Bottom,
  },
  data() {
    return {
      res: null,
      policyData: null,
      isShowAgreement: false,
      isShowSelect: true,
      isClicked: false,
      isShowPolicy: false,
      purchaseSuccess: false,
    };
  },

  computed: {
    sensorRes() {
      if (this.res && this.res.sensor) {
        return this.res.sensor;
      }
      return null;
    },
    topRes() {
      if (this.res && this.res.top) {
        return this.res.top;
      }
      return null;
    },
    bottomRes() {
      if (this.res && this.res.bottom) {
        return this.res.bottom.button;
      }
      return null;
    },
    buttonType() {
      if (
        this.res &&
        this.res.bottom &&
        this.res.bottom.button &&
        this.res.bottom.button.type
      ) {
        return this.res.bottom.button.type;
      }
      return '';
    },
    isRemain() {
      if (
        this.res &&
        this.res.bottom &&
        this.res.bottom.button &&
        parseInt(this.res.bottom.button.remain) < 1000
      ) {
        return true;
      }
      return false;
    },
    contentRes() {
      if (this.res && this.res.content) {
        return this.res.content;
      }
      return null;
    },
    headerRes() {
      if (this.res && this.res.header) {
        return this.res.header;
      }
      return null;
    },
    isSwitch() {
      if (
        this.res &&
        this.res.user_agreement &&
        this.res.user_agreement.switch
      ) {
        return this.res.user_agreement.switch;
      }
      return 0;
    },
    agreementRes() {
      if (this.res && this.res.user_agreement) {
        return this.res.user_agreement;
      }
      return null;
    },
    agreeColor() {
      if (
        this.res &&
        this.res.user_agreement &&
        this.res.user_agreement.color
      ) {
        return this.res.user_agreement.color;
      }
      return '';
    },
    txtColor() {
      if (
        this.res &&
        this.res.user_agreement &&
        this.res.user_agreement.txt_color
      ) {
        return this.res.user_agreement.txt_color;
      }
      return '';
    },
    selectColor() {
      if (
        this.res &&
        this.res.user_agreement &&
        this.res.user_agreement.select_color
      ) {
        return this.res.user_agreement.select_color;
      }
      return '';
    },
    agName() {
      if (
        this.res &&
        this.res.user_agreement &&
        this.res.user_agreement.agreement_name
      ) {
        return this.res.user_agreement.agreement_name;
      }
      return '';
    },
    agPrefix() {
      if (
        this.res &&
        this.res.user_agreement &&
        this.res.user_agreement.agreement_prefix
      ) {
        return this.res.user_agreement.agreement_prefix;
      }
      return '';
    },
  },
  created() {
    if (this.res && this.res.user_agreement) {
      this.isClicked = !this.res.user_agreement.check;
    }
  },
  mounted() {
    window.addEventListener('touchstart', this.touchStartHandle);
    window.addEventListener('touchend', this.touchEndHandle);
  },
  beforeDestroy() {
    window.removeEventListener('touchstart', this.touchStartHandle);
    window.removeEventListener('touchend', this.touchEndHandle);
  },

  methods: {
    async sendGetActivityReq() {
      await window.apis
        .getActivityReq(
          {
            id: parseInt(this.$route.params.id),
          },
          this.$route.query
        )
        .then((res) => {
          if (res && res.data && res.data.sensor) {
            const sensor = res.data.sensor;
            // 页面浏览埋点
            trackerLoaded.then((tracker) => {
              patchTracker(tracker).track('PageView', {
                tracking_scene: '618活动报名页',
                tracking_subscene: '浏览618活动页',
                production_id: Number(sensor.production_id),
                production_type: sensor.production_type,
                original_price: Number(sensor.original_price),
                from: sensor.from,
                from_version: sensor.from_version,
                user_types: sensor.user_types,
                is_allow: sensor.is_allow,
              });
            });
          }

          // 重定向
          if (res && res.data && res.data.redirect) {
            window.location.href = res.data.redirect;
          }

          // 初始化
          if (res && res.data) {
            this.res = res.data;
          }
        })
        .catch((e) => {
          console.log(e);
          // alert(e.message);
        });
    },
    async sendGetChargeStatusReq() {
      const id = this.getChargeId();
      if (id) {
        this.chargeId = id;
      }
      this.getChargeStatus(id).then((data) => {
        if (this.isSetPolling()) {
          this.registerPolling(id);
        }
      });
    },
    async sendGetPolicyReq() {
      window.apis.getPolicy().then((res) => {
        this.policyData = {
          agreement_name: res.data.title,
          agreement_detail: res.data.content,
          update_time: res.data.update_time,
          effect_time: res.data.effect_time,
        };
      });
    },
    getChargeStatus(id) {
      const SearchQuery = getQueryFromSearch();
      return window.apis
        .getChargeStatusReq({
          charge_id: id,
          ...this.$route.query,
          ...SearchQuery,
        })
        .then((res) => {
          const { data } = res;
          this.purchaseSuccess = Boolean(data.is_success);
          if (this.purchaseSuccess) {
            this.sendGetActivityReq();
          }
          return data;
        });
    },
    isSetPolling() {
      const id = this.getChargeId();
      const query = {
        ...this.$route.query,
        ...getQueryFromSearch(),
      };
      if (query.random || id) {
        return true;
      }
      return false;
    },
    getChargeId() {
      const id = this.$route.query.charge_id;
      if (id) {
        return id;
      } else {
        return getCookie(CHARGE_ID);
      }
    },
    registerPolling(id) {
      this.timeInterval = setTimeout(() => {
        this.getChargeStatus(id).then((data) => {
          if (!data.is_success) {
            this.registerPolling(id);
          }
        });
      }, INTERVAL);
    },
    showAgreement() {
      this.isShowAgreement = true;
    },
    closeHandle() {
      this.isShowAgreement = false;
    },
    agreeHandle(val) {
      this.isClicked = val;
    },
    showPolicy() {
      this.isShowPolicy = true;
    },
    closePolicy() {
      this.isShowPolicy = false;
    },
    touchStartHandle() {
      this.offset =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
    },

    touchEndHandle() {
      const scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      // 滑动页面埋点
      if (Math.abs(this.offset - scroll) > 20) {
        const { From, FromVersion } = this.$route.query;
        trackerLoaded.then((tracker) => {
          patchTracker(tracker).track('PageScroll', {
            tracking_scene: '618活动报名页',
            tracking_subscene: '618活动页',
            production_id: Number(this.sensorRes.production_id),
            production_type: this.sensorRes.production_type,
            original_price: Number(this.sensorRes.original_price),
            page_name: '618活动页',
            roll_direction: scroll - this.offset > 0 ? 'down' : 'up',
            start_v: Number(this.offset),
            end_v: Number(scroll),
            from: From || 'unknown',
            from_version: FromVersion || 'unknown',
          });
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.sendGetActivityReq();
      // await vm.sendGetChargeStatusReq();
      await vm.sendGetPolicyReq();
    });
  },
};
</script>

<style lang="scss" scoped>
#page {
  position: relative;

  .agreement-btn {
    position: absolute;
    bottom: 160px;
    left: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transform: translateX(-50%);

    .select-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;

      .selected {
        width: 24px;
        height: 24px;
        border-radius: 4px;
      }

      .unselect {
        width: 24px;
        height: 24px;
        border: solid 2px #979797;
        border-radius: 4px;
      }
    }
    .option-text {
      display: block;
      font-size: 20px;
      white-space: nowrap;
      opacity: 0.6;
    }
    .option-agreement {
      display: block;
      font-size: 20px;
      white-space: nowrap;
    }
  }
  .remainPreAgre {
    bottom: 345px;
    bottom: calc(345px + env(safe-area-inset-bottom));
    bottom: calc(345px + constant(safe-area-inset-bottom));
  }
  .noremainPreAgre {
    bottom: 289px;
    bottom: calc(289px + env(safe-area-inset-bottom));
    bottom: calc(289px + constant(safe-area-inset-bottom));
  }
  .remainFinalAgre {
    bottom: 388px;
    bottom: calc(388px + env(safe-area-inset-bottom));
    bottom: calc(388px + constant(safe-area-inset-bottom));
  }
  .noremainFinalAgre {
    bottom: 332px;
    bottom: calc(332px + env(safe-area-inset-bottom));
    bottom: calc(332px + constant(safe-area-inset-bottom));
  }
}
.remainPre {
  padding-bottom: 220px;
  padding-bottom: calc(220px + env(safe-area-inset-bottom));
  padding-bottom: calc(220px + constant(safe-area-inset-bottom));
}
.noremainPre {
  padding-bottom: 164px;
  padding-bottom: calc(164px + env(safe-area-inset-bottom));
  padding-bottom: calc(164px + constant(safe-area-inset-bottom));
}
.remainFinal {
  padding-bottom: 263px;
  padding-bottom: calc(263px + env(safe-area-inset-bottom));
  padding-bottom: calc(263px + constant(safe-area-inset-bottom));
}
.noremainFinal {
  padding-bottom: 207px;
  padding-bottom: calc(207px + env(safe-area-inset-bottom));
  padding-bottom: calc(207px + constant(safe-area-inset-bottom));
}
.guide {
  padding-bottom: 108px;
  padding-bottom: calc(108px + env(safe-area-inset-bottom));
  padding-bottom: calc(108px + constant(safe-area-inset-bottom));
}
</style>
